/*
* Copyright (c) 2023 Eugenio Espinoza
*
* Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"),
* to use the Software solely for personal, non-commercial purposes. Any commercial use, distribution, sublicense, sale, or modification of the Software
* is strictly prohibited without the explicit written permission of the copyright holder.
*
* For licensing inquiries, please contact Eugenio Espinoza at mail.eugenioespinoza.com .
*
* THE SOFTWARE IS PROVIDED "AS IS," WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
* FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
* WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
*/


import React from 'react';
import { useState } from 'react';
import "./DonAeroProfile.css";

function DonAeroProfile() {

  const Aerotours = [
    // {
    //   date: '2023-05-01',
    //   title: 'Tour 1',
    //   location: 'New York',
    //   ticketLink: 'https://example.com/tour-1-tickets',
    // },
    // {
    //   date: '2023-05-10',
    //   title: 'Tour 2',
    //   location: 'Los Angeles',
    //   ticketLink: 'https://example.com/tour-2-tickets',
    // },
    // {
    //   date: '2023-05-20',
    //   title: 'Tour 3',
    //   location: 'Chicago',
    //   ticketLink: 'https://example.com/tour-3-tickets',
    // },
  ];


  const formatDate = (dateString) => {
      const date = new Date(dateString);
      const month = date.toLocaleString('en-US', { month: 'short' });
      const day = date.getDate();
      const year = date.getFullYear();
      return `${month} ${day}, ${year}`;
    };
  const buyTicket = (tour) => {
    // alert(`Buying a ticket for ${tour.title} in ${tour.location} on ${tour.date}`);
    window.open(tour.ticketLink, '_blank');
  };

  

  /* Show More button Fuction */
  const [showFullBio, setShowFullBio] = useState(false);
  const handleToggleBio = () => {
    setShowFullBio(!showFullBio);
  };



  return (
    <div>
      <div className="donaero-banner">
        {/* <img className="profile-pic" src="https://i1.sndcdn.com/artworks-000012755519-fd1mrr-t500x500.jpg" alt="Artist Profile" /> */}
      </div>
  {/* Artist's About Section*/}
  <div className="artist-info-container">
    <div className="artist-excerpt-container">
      <h1 className="entry-title">Don Aero</h1>
        <p>
          En 1999 Don Aero toma el papel y la tinta para pintar ideas dando inicio a su trayectoria utilizando los recursos de la web 
          descargando tracks instrumentales de reconocidos productores, con los cuales para el año 2000 graba su primer 
          material en cassete titulado “Aerodinámico” mismo que sólo fue distribuido entre amigos y conocidos. 
        </p>
    {showFullBio ? (
      <>
        {[      
        "En 2001 Se forma el grupo Soxiedad Anonima junto a Iofeck y Vocal en sus inicios y años más tarde se integra Sicko a la agrupación.", 
        "Este proyecto permanecio vigente varios años y abrio muchas puertas para el hip hop en Tijuana siendo uno de los primeros grupos que movilizara el género.",
        "Tras la separación del grupo en el 2006 Don Aero decide lanzar su primer material discográfico titulado “Subele Volumen” disco con el cual dió inicio a una trayectoria musical como solista. En donde se incluyen temas como “Maria Juana”, “A La Ve*ga” “Papas Con Que” “Subele Volumen”.",
        "En 2008 Don Aero Volvió con nueva producción bajo el nombre de “REVOLVER” siendo este una gran consolidación de un nuevo estilo musical con ritmos agresivos y un estilo lirico muy peculiar.",
        "Para el 2010 Lanza su nuevo material discográfico impregnado de nuevas corrientes musicales, por supuesto sin dejar a un lado su estilolírico metafórico.",
        "Dicho disco fue grabado en Strategia Studio,mezclado y masterizado por Dante Storch para SateliteMusic Inc. y Master Records.",
      "Tras su salido de Satelite Music y ante el rechazo de contrato que le ofrecio Metodo Producciones Music el rapero tijuanense Don Aero firma con la disquera Mastered Trax, en  sello que se encargará de la promoción del cantante en sus próximos proyectos como solista en 2014.",
      "Esta parece ser una muy buena mancuerna para la expansión de la carrera del rapero; Mastered Trax ya cuenta en sus filas con cantantes como C-Kan, Don Kalavera, entre otros.",
      "Se augura un próximo hit internacional a Don Aero con su nuevo material discografico titulado “DE BOCA EN BOCA”."    
      ].map((text, index) => (
          <React.Fragment key={index}>
            {text.endsWith(".") ? (
              <>
                {text}
                <br />
              </>
            ) : (
              <>{text}</>
            )}
          </React.Fragment>
        ))}
        <button className="see-more" onClick={handleToggleBio}> Ver Menos</button>
      </>
    ) : (
      <button className="see-more" onClick={handleToggleBio}> Ver Mas</button>
    )}
        <div className="social-links">
          <a href="https://www.facebook.com/donaerohiphop" rel="noopener noreferrer" target="_blank" className="artist-social-link">
            <i className="fab fa-facebook"></i>
          </a>
          <a href="https://www.instagram.com/donaerohiphop/" rel="noopener noreferrer" target="_blank" className="artist-social-link">
            <i className="fab fa-instagram"></i>
          </a>
          <a href="https://www.youtube.com/channel/UCaEZ1OAjebcZOnVcNhBZrZQ" rel="noopener noreferrer" target="_blank" className="artist-social-link">
            <i className="fab fa-youtube"></i>
          </a>
        </div>
      </div>
      <div className="artist-meta-container">
          <div className="artist-location artist-meta ">
              <h3>Ciudad</h3>
              <p>Tijuana, MX</p>
            </div>
            <div className="artist-genre artist-meta">
              <h3>Genero</h3>
              <p>Hip-Hop</p>
            </div>
            <div className="artist-website artist-meta">
                <h3>Instagram</h3>
                <a href="https://www.instagram.com/donaerohiphop/"rel="noopener noreferrer" target="_blank">
                  <span>@DonAerohiphop</span>
                </a>
            </div>
            <div className="artist-email artist-meta">
                <h3>Booking</h3>
                <a href="mailto: joe@masteredtrax.com" rel="noopener noreferrer">
                  <span>joe@masteredtrax.com</span>
                </a>
          </div>
      </div>
</div>
{/* Artist's Music Section*/}
  <div id='music'>
    <h1 className="music-section-title">MUSICA</h1>
    <div className="music-section">
      <div className="column youtube">
        <div className="music-wrap">
          <iframe
            title="YouTube Video"
            src="https://www.youtube.com/embed/Sxq-TYHiS5c"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
      </div>
      <div className="column spotify">
        <div className="music-wrap">
          <iframe
            title="Spotify Player"
            src="https://open.spotify.com/embed/playlist/37i9dQZF1DZ06evO1wp2IU?utm_source=generator&theme=0"
            width="100%"
            height="352"
            frameBorder="0"
            allowFullScreen=""
            allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
            loading="lazy"
          ></iframe>
        </div>
      </div>
    </div>  
  </div>
{/* Artist's Tour Section*/}

<div id="tour">
        <h1 className="tour-section-title">TOUR</h1>
        {Aerotours.length > 0 ? (
          <div className="tour-section">
            <table className="tour-table">
              <thead>
                <tr>
                  <th>Fecha</th>
                  <th>Título</th>
                  <th>Ubicación</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {Aerotours.map((tour, index) => (
                  <tr key={index}>
                    <td id="event-date">{formatDate(tour.date)}</td>
                    <td id="event-title">{tour.title}</td>
                    <td id="event-location">{tour.location}</td>
                    <td id="button-container">
                      <button onClick={() => buyTicket(tour)}>Comprar boleto</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <div className="tour-section">
            <p>No hay eventos programados.</p>
          </div>
        )}
      </div>
    </div>
  );
}
export default DonAeroProfile;